import { message } from 'antd'
import { ApiAuthError } from '@sisyphe/utils'

let lastMessage = ''

export const onApiError = history => err => {
  const errorMessage = err?.message ?? '发生未知错误，请重试'

  if (errorMessage !== lastMessage) {
    lastMessage = errorMessage
  } else {
    message.destroy()
  }

  message.error(errorMessage)

  if (err instanceof ApiAuthError) {
    console.log('服务端鉴权失败。')
    history.push('/login')
  }
}
